
import React from 'react';

const Loading = () => (
    // <div className="content">
		// 	<p>Loading ...</p>
		// </div>
		<div id="page-loader" className="fade show">
			<span className="spinner"></span>
		</div>
);
 
export default Loading;